/**
 * HeroBlockV3 Standalone Entry Point
 *
 * This file is intentionally minimal and serves as a standalone entry point for the HeroBlockV3 component.
 *
 * ARCHITECTURE EXPLANATION:
 *
 * This project uses a dual-usage pattern for components that need to work both as:
 * 1. Standalone mountable components (with their own reactMount calls)
 * 2. Imported components within other pages
 *
 * WHY THIS FILE EXISTS:
 * - The actual HeroBlockV3 component logic lives in @/components/HeroBlockV3.js
 * - This file only handles the standalone mounting via reactMount()
 * - This prevents webpack bundling conflicts when the same component is used both ways
 *
 * HOW IT WORKS:
 * - Pages that need to mount HeroBlockV3 directly use this file (via webpack entry)
 * - Other components import the pure component from @/components/HeroBlockV3
 * - Webpack creates separate bundles without conflicts
 *
 * WEBPACK CONFIG:
 * - This file is defined as an entry point in webpack.config.js
 * - The component file is NOT an entry point, preventing circular dependency issues
 *
 * USAGE EXAMPLES:
 * - Standalone: <div data-react-mount="HeroBlockV3" data-umbraco='...'></div>
 * - Imported: import { HeroBlockV3 } from '@/components/HeroBlockV3'
 */

import { HeroBlockV3 } from '@/components/HeroBlockV3';
import { reactMount } from '@/lib/reactMount';

reactMount('HeroBlockV3', HeroBlockV3);
